export const SERVICE_PROCESS_STEPS = [
  {
    title: "Find the Right Professional",
    description:
      "Explore professionals based on experience, language, availability, session mode, and budget.",
  },
  {
    title: "Begin With a Private Conversation",
    description:
      "Share what you'd like support with and what you hope to gain from your sessions.",
  },
  {
    title: "Build Healthier Patterns Together",
    description:
      "Work on the thoughts, habits, or patterns that matter most to you, at a comfortable pace.",
  },
];

export const SERVICE_WHY_ITSHEALER_POINTS = [
  { icon: "ShieldCheck", label: "Specialist, licensed professionals" },
  { icon: "Lock", label: "Private and confidential sessions" },
  { icon: "Users", label: "Support for individuals, couples, and families" },
  { icon: "Globe2", label: "Culturally sensitive conversations" },
  { icon: "CalendarClock", label: "Flexible online appointments" },
  { icon: "ReceiptText", label: "Transparent profiles and pricing" },
] as const;
